import React, { useState, useEffect } from 'react';
import './MassnahmenModal.css';

const MassnahmenModal = ({ risiko, massnahme, onClose, onSave }) => {
    const [formData, setFormData] = useState({
        massnahme_titel: '',
        massnahme_beschreibung: '',
        massnahme_typ: 'praeventiv',
        verantwortlicher: '',
        prioritaet: 'mittel',
        status: 'geplant',
        geplantes_datum: '',
        umsetzungsdatum: '',
        kosten: ''
    });

    useEffect(() => {
        if (massnahme) {
            setFormData({
                massnahme_titel: massnahme.massnahme_titel || '',
                massnahme_beschreibung: massnahme.massnahme_beschreibung || '',
                massnahme_typ: massnahme.massnahme_typ || 'praeventiv',
                verantwortlicher: massnahme.verantwortlicher || '',
                prioritaet: massnahme.prioritaet || 'mittel',
                status: massnahme.status || 'geplant',
                geplantes_datum: massnahme.geplantes_datum || '',
                umsetzungsdatum: massnahme.umsetzungsdatum || '',
                kosten: massnahme.kosten || ''
            });
        }
    }, [massnahme]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        const payload = {
            risiko_id: risiko.risiko_id,
            massnahme_titel: formData.massnahme_titel,
            massnahme_beschreibung: formData.massnahme_beschreibung || null,
            massnahme_typ: formData.massnahme_typ || null,
            verantwortlicher: formData.verantwortlicher || null,
            prioritaet: formData.prioritaet || null,
            status: formData.status || 'geplant',
            geplantes_datum: formData.geplantes_datum || null,
            umsetzungsdatum: formData.umsetzungsdatum || null,
            kosten: formData.kosten ? parseFloat(formData.kosten) : null
        };

        if (massnahme) {
            onSave(massnahme.massnahme_id, payload);
        } else {
            onSave(payload);
        }
    };

    return (
        <div className="modal-overlay" onClick={onClose}>
            <div className="modal massnahmen-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <div>
                        <h2>{massnahme ? 'Maßnahme bearbeiten' : 'Neue Maßnahme erfassen'}</h2>
                        <p className="modal-subtitle">
                            Für Risiko: {risiko.risiko_bezeichnung}
                        </p>
                    </div>
                    <button className="modal-close" onClick={onClose}>×</button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <div className="form-group">
                            <label className="form-label">
                                Maßnahmentitel <span className="required">*</span>
                            </label>
                            <input
                                type="text"
                                name="massnahme_titel"
                                className="form-input"
                                value={formData.massnahme_titel}
                                onChange={handleChange}
                                required
                                placeholder="z.B. Firewall-Upgrade durchführen"
                            />
                        </div>

                        <div className="form-group">
                            <label className="form-label">Beschreibung</label>
                            <textarea
                                name="massnahme_beschreibung"
                                className="form-textarea"
                                value={formData.massnahme_beschreibung}
                                onChange={handleChange}
                                rows="3"
                                placeholder="Detaillierte Beschreibung der Maßnahme..."
                            />
                        </div>

                        <div className="form-grid">
                            <div className="form-group">
                                <label className="form-label">Typ</label>
                                <select
                                    name="massnahme_typ"
                                    className="form-select"
                                    value={formData.massnahme_typ}
                                    onChange={handleChange}
                                >
                                    <option value="praeventiv">Präventiv</option>
                                    <option value="detektiv">Detektiv</option>
                                    <option value="korrektiv">Korrektiv</option>
                                </select>
                            </div>

                            <div className="form-group">
                                <label className="form-label">Priorität</label>
                                <select
                                    name="prioritaet"
                                    className="form-select"
                                    value={formData.prioritaet}
                                    onChange={handleChange}
                                >
                                    <option value="niedrig">Niedrig</option>
                                    <option value="mittel">Mittel</option>
                                    <option value="hoch">Hoch</option>
                                    <option value="kritisch">Kritisch</option>
                                </select>
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">Verantwortlicher</label>
                            <input
                                type="text"
                                name="verantwortlicher"
                                className="form-input"
                                value={formData.verantwortlicher}
                                onChange={handleChange}
                                placeholder="Name des Verantwortlichen"
                            />
                        </div>

                        <div className="form-grid">
                            <div className="form-group">
                                <label className="form-label">Geplantes Datum</label>
                                <input
                                    type="date"
                                    name="geplantes_datum"
                                    className="form-input"
                                    value={formData.geplantes_datum}
                                    onChange={handleChange}
                                />
                            </div>

                            <div className="form-group">
                                <label className="form-label">Kosten (€)</label>
                                <input
                                    type="number"
                                    name="kosten"
                                    className="form-input"
                                    value={formData.kosten}
                                    onChange={handleChange}
                                    step="0.01"
                                    placeholder="0.00"
                                />
                            </div>
                        </div>

                        <div className="form-group">
                            <label className="form-label">Status</label>
                            <select
                                name="status"
                                className="form-select"
                                value={formData.status}
                                onChange={handleChange}
                            >
                                <option value="geplant">Geplant</option>
                                <option value="in_umsetzung">In Umsetzung</option>
                                <option value="abgeschlossen">Abgeschlossen</option>
                            </select>
                        </div>
                    </div>

                    <div className="modal-actions">
                        <button type="button" onClick={onClose} className="btn-secondary">
                            Abbrechen
                        </button>
                        <button type="submit" className="btn-primary">
                            {massnahme ? 'Änderungen speichern' : 'Maßnahme speichern'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default MassnahmenModal;
